// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__YLEEV","clinicsSelect":"TableHeading_clinicsSelect__FKYxL"};